export const ENHANCED_VIEWER = "enhanced_viewer";
export const PDF_VIEWER = "pdf_viewer";
export const VIDEO_VIEWER = "video_viewer";
export const IMAGE_VIEWER = "image_viewer";
export const AUDIO_VIEWER = "audio_viewer";
export const DEFAULT_VIEWER = "default_viewer";
export const HTML_VIEWER = "html_viewer";
export const CLEVERSTORY_VIEWER = "cleverstory_viewer";
export const DOCUSIGN_VIEWER = "docusign_viewer";
export const RENDER_IN_VIEWER = "render_in_viewer";
export const RENDER_OPTIMIZED_VIEW = "render_optimized_view";
export const EXCEL_VIEWER = "excel_viewer";
export const SCORM_VIEWER = "scorm_viewer";
export const PAGE_ANALYTICS = "PAGE_ANALYTICS";
export const VIDEO_ANALYTICS = "VIDEO_ANALYTICS";
export const AUDIO_ANALYTICS = "AUDIO_ANALYTICS";
export const SPREADSHEET_VIEWER = "spreadsheet_viewer";
export const HTML_APP_VIEWER = "html_app_viewer";